module.exports = __webpack_public_path__ + "img/lengjingze.94df311c.png";